import { PUT } from "../../API/put";
import { usersRef } from "../../firebase";
import { getUserInfo, removeUserInfo } from "../../storage";
import { showNotification } from '../notifications/notifications';


export const getCustomerDetailsInFirebase = async (setAdminDetails) => {
    const user_info = getUserInfo();
    const documentId = user_info?.customer_firebase_document_id?.trim();

    if(documentId){
        let query = usersRef.doc(documentId);

        query.onSnapshot(async (doc) => {
            if (doc.exists) {
                setAdminDetails({
                    doc_id: doc.id,
                    ...doc.data()
                });
            } 
        });
    }
}

export const logoutCustomer = async (navigate) => {
    const user_info = getUserInfo();
    
    showNotification({
        notificationType: 'LOGOUT_CUSTOMER', 
        preConfirm: async () => {
            const response = await PUT("customer/logout", {
                customer_id: user_info?.customer_id
            });
            return response;
        },
        isConfirmed: () => {
            removeUserInfo();
            navigate('/');
        }
    });
}
